module.exports = __webpack_public_path__ + "media/fx0248.30288538.wav";